"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _urijs = _interopRequireDefault(require("urijs"));
var _TableManager = _interopRequireDefault(require("./TableManager"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var updateUrl = function updateUrl(filters, location, history) {
  history.push(new _urijs["default"](location.pathname).search(filters).toString());
};
var TableManagerRoute = function TableManagerRoute(props) {
  var location = (0, _reactRouterDom.useLocation)();
  var history = (0, _reactRouterDom.useHistory)();
  var searchObject = _urijs["default"].parseQuery(location.search);
  var populatedTableHeaders = props.tableHeaders.map(function (tableHeader) {
    return _objectSpread(_objectSpread({}, tableHeader), {}, {
      value: searchObject[tableHeader.dataKey]
    });
  });
  var populatedDropdownFilters = props.dropdownFilters.map(function (dropdownFilter) {
    return _objectSpread(_objectSpread({}, dropdownFilter), {}, {
      value: searchObject[dropdownFilter.dataKey]
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: props.path
  }, /*#__PURE__*/_react["default"].createElement(_TableManager["default"], _extends({}, props, {
    tableHeaders: populatedTableHeaders,
    dropdownFilters: populatedDropdownFilters,
    afterStateUpdate: function afterStateUpdate(filters) {
      return updateUrl(filters, location, history);
    }
  })));
};
TableManagerRoute.propTypes = _objectSpread(_objectSpread({}, _TableManager["default"].propTypes), {}, {
  path: _propTypes["default"].string
});
TableManagerRoute.defaultProps = {
  path: "/experiments"
};
var _default = exports["default"] = TableManagerRoute;